import { useEffect, useState, useRef } from "react";
import { Title, Box, Group, Stack, Grid, LoadingOverlay } from "@mantine/core";
import { useNavigate, useParams } from "react-router-dom";
import { PageWithBreadcrumbs } from "../../components/layout/PageWithBreadcrumbs";
import { ContainerWhite } from "../../components/core/ContainerWhite/ContainerWhite";
import { AfaButton, AfaFieldDisplay, AfaCommentHistory, AfaPageLoader, AfaDocumentHistory } from "../../components/ui";
import AfaAlert from "../../components/ui/AfaAlert/AfaAlert";
import { InfoInteresseModal } from "../../components/Modals/InfoInteresseModal";
import { tramesesGroupedType } from "../../interface/trameses";
import { DeleteTramesaModal } from "../../components/Modals/DeleteTramesaModal/DeleteTramesaModal";
import { CancelTramesaModal } from "../../components/Modals/CancelTramesaModal/CancelTramesaModal";
import { UploadDocumentacioTramesaModal } from "../../components/Modals/UploadDocumentacioTramesaModal/UploadDocumentacioTramesaModal";
import moment from "moment";

export function TramesesDetall(props: any) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [guid, setGuid] = useState("");
  const [modalOpened, setModalOpened] = useState(false);
  const [state, setDetallState] = useState("");
  const [referencePeriodMonth, setReferencePeriodMonth] = useState("");
  const [referencePeriodYear, setReferencePeriodYear] = useState("");
  const [otherReceivers, setOtherReceivers] = useState<string[]>([]);
  const [comments, setComments] = useState<any[]>([]);
  const [groups, setGroups] = useState<tramesesGroupedType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [noAccess, setNoAccess] = useState<boolean>(false);
  const [documents, setDocuments] = useState([]);
  const [documentsAfa, setDocumentsAfa] = useState([]);
  const [data, setData] = useState(null as any)
  const formRef = useRef<HTMLFormElement>(null);
  const [cancelModalOpened, setCancelModalOpened] = useState<boolean>(false);
  const [deleteModalOpened, setDeleteModalOpened] = useState<boolean>(false);
  const [uploadDocModalOpened, setUploadDocModalOpened] = useState<boolean>(false);
  const [downloadingDoc, setDownloadingDoc] = useState<boolean>(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sendDocs = params.get("sendDocs");

    props.apiService
      .GetTramesaById(id, props.entity.lookupId)
      .then((data: any) => {
        if (data.id === 0) {
          setNoAccess(true);
          setLoading(false);
          return;
        }
        setData(data);
        setDetallState(data.state);
        setReferencePeriodMonth(data.referencePeriodMonth);
        setReferencePeriodYear(data.referencePeriodYear);
        setOtherReceivers(Array.isArray(data.otherReceivers) ? data.otherReceivers : []);
        setComments(Array.isArray(data.comments) ? data.comments : []);
        setDocuments(Array.isArray(data.docs) ? data.docs : []);
        setDocumentsAfa(Array.isArray(data.docsAFA) ? data.docsAFA : []);
        setGuid(data.guid)

        if (sendDocs && (data.state === "Pendent rebre documentació" || data.fase === "Validació i Anàlisi")) setUploadDocModalOpened(true);

        try {
          const parsed: tramesesGroupedType[] = JSON.parse(data.formJson);
          if (Array.isArray(parsed)) {
            setGroups(parsed);
          } else {
            setGroups([]);
          }
          setLoading(false);
        } catch (err) {
          setGroups([]);
          setLoading(false);
        }
      })
      .catch((error: any) => {
        console.error("Error:", error);
      });
  }, []);


  const handleDownload = (fileName: string, url: string) => {
    setDownloadingDoc(true);
    props.apiService.DownloadDocumentOV(url).then((blob: Blob) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();

      URL.revokeObjectURL(link.href);
    }).catch((error: any) => {
      console.error("Error al descargar el documento:", error);
    }).finally(() => {
      setDownloadingDoc(false);
    });
  };

  return (
    <PageWithBreadcrumbs>
      <Title order={1}>Detall de la Tramesa: {guid}</Title>

      <ContainerWhite>
        {loading ?
          <AfaPageLoader description="Carregant el detall..."></AfaPageLoader>
          : noAccess ?
          <AfaAlert type="error" title="Sense permisos">
            No tens permisos per visualitzar aquesta tramesa.
          </AfaAlert>
          :
          <>
            <Box bg="brand.0" p="md" style={{ borderRadius: "8px" }}>
              <Group gap="xl" align="flex-start">
                <AfaFieldDisplay
                  label="Entitat"
                  value={props.entity != null ? props.entity.lookupValue : ""}
                  style={{ flex: 1 }}
                />
                <AfaFieldDisplay
                  label="Informació d'interès"
                  button={{
                    text: "Consultar informació",
                    onClick: () => setModalOpened(true),
                    id: "btn-consultar-info",
                  }}
                  style={{ flex: 1 }}
                />
                <AfaFieldDisplay
                  label="Estat"
                  badge={{
                    color: {
                      'Pendent rebre documentació': 'orange',
                      'Cancel·lat entitat': 'lilac',
                      'Rebutjat AFA': 'red',
                      'Tramès': 'green',
                      'Esborrany': 'blue'
                    }[state] ?? 'yellow' as any,
                    variant: "filled",
                    text: state
                  }}
                  style={{ flex: 1 }}
                />
              </Group>
            </Box>

            {/* Dades generals */}
            <Box mt="md">
              <Stack gap="md">
                <Group align="flex-start">
                  <AfaFieldDisplay
                    label="Vull iniciar una tramesa referent a una"
                    value={data.filial.lookupId !== -1 ? "Filial" : "Entitat"}
                    style={{ flex: 1 }}
                  />
                  {data.filial.lookupId !== -1 &&
                    <AfaFieldDisplay
                      label="Filial"
                      value={data.filial.lookupValue}
                      style={{ flex: 1 }}
                    />
                  }
                </Group>

                <Group align="flex-start">
                  <AfaFieldDisplay
                    label="Tipologia de tramesa"
                    value={data?.tramesaType?.lookupValue}
                    style={{ flex: 1 }}
                  />
                </Group>

                <Group align="flex-start" wrap="nowrap" gap="md">
                  <AfaFieldDisplay
                    label="Altres destinataris"
                    value={otherReceivers?.join(", ") ?? ""}
                    style={{ flex: "0 0 calc(50% - 8px)" }}
                  />
                  <AfaFieldDisplay
                    label="Període de referència"
                    value={referencePeriodMonth}
                    style={{ flex: "0 0 calc(25% - 8px)" }}
                  />
                  <AfaFieldDisplay
                    label="Any"
                    value={referencePeriodYear}
                    style={{ flex: "0 0 calc(25% - 8px)" }}
                  />
                </Group>

                {data.cancelledReason && (state == "Rebutjat AFA" || state == "Cancel·lat entitat") &&
                  <Group align="flex-start" wrap="nowrap" gap="md">
                    <AfaFieldDisplay
                      label="⚠️ Motiu de cancel·lació"
                      value={data.cancelledReason}
                    />
                  </Group>
                }

                {data.dateTermini && state == "Pendent rebre documentació" &&
                  <Group align="flex-start" wrap="nowrap" gap="md">
                    <AfaFieldDisplay
                      label="⚠️ Data termini"
                      value={moment(data.dateTermini).format('YYYY-MM-DD')}
                    />
                  </Group>
                }

              </Stack>
            </Box>

            {/* Comentaris */}
            <Title order={3} mt="xl">
              Històric comentaris amb AFA
            </Title>
            <Box mt="xs">
              <AfaCommentHistory comments={comments} />
            </Box>

            <p></p>
            {/* Formulari */}
            <form ref={formRef} style={{ marginTop: '40px' }}>
              {groups.length > 0 && (
                <div style={{ marginBottom: '20px' }}>
                  <Title order={3}>Formulari</Title>
                  <hr />
                </div>
              )}

              <Group align="flex-start">
                <div style={{ flex: 1 }}>
                  {groups.map((group) => (
                    <div
                      key={group.groupName}
                      style={{ marginBottom: "24px" }}
                    >
                      <Title order={3}>{group.groupName}</Title>
                      <Box mt="xs">
                        <Stack gap="xs">
                          <Grid gutter="md">
                            {group.fields
                              .sort((a, b) => a.order - b.order)
                              .map((field, index) => {
                                let span = 12;
                                if (field.colsNumber === 2) span = 6;
                                if (field.colsNumber === 3) span = 4;

                                return (
                                  <Grid.Col
                                    key={`${group.groupName}-${field.title}`}
                                    span={span}
                                  >
                                    <AfaFieldDisplay
                                      label={field.title}
                                      value={field.value?.toString()}
                                      style={{ flex: 1 }}
                                    />
                                  </Grid.Col>
                                );
                              })}
                          </Grid>
                        </Stack>
                      </Box>
                    </div>
                  ))}
                </div>
              </Group>
            </form>


            {/* Documentació */}
            <Box pos="relative">
              <LoadingOverlay visible={downloadingDoc} loaderProps={{ type: 'bars' }} overlayProps={{ blur: 2 }} />
              <Title order={3} mt="xl">Documents AFA</Title>
              <AfaDocumentHistory
                documents={documentsAfa}
                onDownload={handleDownload}
                emptyMessage="No hi ha documents de AFA per mostrar."
                maxHeight="260px"
              />

              <Title order={3} mt="xl">Documents</Title>
              <AfaDocumentHistory
                documents={documents}
                onDownload={handleDownload}
                emptyMessage="No hi ha documents del usuari per mostrar."
                maxHeight="260px"
              />
            </Box>

          </>
        }
        {/* Cabecera informativa */}
      </ContainerWhite>

      {/* Botones de acción */}
      <Group justify="space-between" mt="xs">
        <AfaButton
          id="btn-tornar"
          variant="outline"
          onClick={() => navigate("/trameses/consultar")}
        >
          Tornar
        </AfaButton>

        <Group gap="md">
          {/* <AfaButton
            id="btn-mode"
            variant="outline"
            onClick={() => setReadOnlyMode((prev) => !prev)}
          >
            {readOnlyMode ? "Veure" : "Veure"}
          </AfaButton> */}

          {state === "Tramès" &&
            <AfaButton id="btn-cancelar" variant="outline" color="red" onClick={() => setCancelModalOpened(true)}>
              Cancel·lar
            </AfaButton>
          }

          {((state === "Pendent rebre documentació" || data?.fase === "Validació i Anàlisi") && data?.state !== "Esborrany") &&
            <AfaButton
              id="btn-enviar-documentacio"
              variant="filled"
              onClick={() => { setUploadDocModalOpened(true) }}
            >
              Enviar documentació
            </AfaButton>
          }          

          {state === "Esborrany" &&
            <AfaButton
              id="btn-editar"
              variant="filled"
              onClick={() => { navigate("/trameses/editar/" + id) }}
            >
              Editar
            </AfaButton>
          }

          {state === "Esborrany" && data.createdBy.lookupId !== -1 && data.createdBy.lookupValue === props.user?.user?.titulo &&
            <AfaButton
              id="btn-enviar-documentacio"
              variant="outline"
              onClick={() => { setDeleteModalOpened(true) }}
            >
              Esborrar
            </AfaButton>
          }

        </Group>
      </Group>

      {/* Modals */}
      <InfoInteresseModal
        opened={modalOpened}
        onClose={() => setModalOpened(false)}
      />

      {/* Modal de cancelación */}
      <CancelTramesaModal
        apiService={props.apiService}
        opened={cancelModalOpened}
        onClose={() => setCancelModalOpened(false)}
        tramesaId={id}
        entityId={props.entity.lookupId}
      />

      {/* Modal de cancelación */}
      <DeleteTramesaModal
        apiService={props.apiService}
        opened={deleteModalOpened}
        onClose={() => setDeleteModalOpened(false)}
        tramesaId={id}
      />

      {/* Modal pujada documentació */}
      <UploadDocumentacioTramesaModal
        apiService={props.apiService}
        opened={uploadDocModalOpened}
        onClose={() => setUploadDocModalOpened(false)}
        tramesaId={id}
        tramesaState={state}
        entityId={props.entity.lookupId}
      />

    </PageWithBreadcrumbs>
  );
}
